import React from 'react';
import { Grid, Modal, Dropdown, Button, Form, Label } from 'semantic-ui-react';
import fpLogo from '../Images/logo.png';
import "../custom.css";


export default class AddProductModal extends React.Component {

    state = {
        SelectedProductGroupId: null,
        SelectedProductXrefId: null,
        SelectedProductCatId: null,
        Quantity: 0,
        Title: 'Add Product',
        ProductWarning: 'Please select a product',
        QtyWarning: 'Please enter a quantity',
        ProductCategoryWarning: 'Please select a category',
        ProductGroupWarning: 'Please select a group',
        CloseModalText: 'Close',
        AddModalText: 'Add'
    }

    CloseModal = () => {
        this.props.CloseAddProductModal();
    }



    handleProductGroupChange = (e, data) => {

        if (data.value === "") {
            this.setState({ SelectedProductGroupId: null });
        }
        else {
            this.setState({ SelectedProductGroupId: data.value });
        }



        //update filteredList to only show whatever product group is selected
        this.props.UpdateFilteredList(data.value, this.state.SelectedProductCatId);
        this.setState({ SelectedProductXrefId: null });

    }

    handleProductChange = (e, data) => {


        if (data.value === "") {
            this.setState({ SelectedProductXrefId: null });
        }
        else {
            this.setState({ SelectedProductXrefId: data.value });
        }

    }

    handleProductCatChange = (e, data) => {

        if (data.value === "") {
            this.setState({ SelectedProductCatId: null });
        }
        else {
            this.setState({ SelectedProductCatId: data.value });
        }



        //update filteredList to only show whatever product group is selected
        this.props.UpdateFilteredProductGroupList(data.value);
        this.setState({ SelectedProductXrefId: null, SelectedProductGroupId: null });

    }

    handleQuantityChange = async (e) => {

        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {

            this.setState({ Quantity: e.target.value }, () => {
            });
        }
    }

    AddToProductList = () => {

        if (this.state.Quantity < 1) {
            return;
        }

        if (this.state.SelectedProductXrefId === null) {
            return;
        }

        this.props.CloseAddProductModal();
        this.props.AddProductToTable(this.state.SelectedProductXrefId, this.state.Quantity);

    }

    render() {

        const productGrpList = this.props.ListOfProductGroups.map(ds => {
            return {
                key: ds.id,
                text: ds.displayText,
                value: ds.id
            }
        });

        const productList = this.props.FilteredListOfProducts.map(ds => {
            return {
                key: ds.xrefId,
                text: ds.product,
                value: ds.xrefId
            }
        });

        const productCatList = this.props.ListOfProductCategories.map(ds => {
            return {
                key: ds.id,
                text: ds.displayText,
                value: ds.id
            }
        });

        return (<div className="ui modal">
            <Modal size='small'
                open={true}
            >

                <Modal.Header>
                    <Grid padded columns={2}>
                        <Grid.Column width={4}>
                            <img src={fpLogo} alt="logo" />
                        </Grid.Column>
                        <Grid.Column verticalAlign="middle" width={12}>
                            <h2>{this.state.Title}</h2>
                        </Grid.Column>
                    </Grid>


                </Modal.Header>

                <Modal.Content>
                    <Grid padded columns={3}>

                        <Grid.Row>

                            <Grid.Column width={1}>
                            </Grid.Column>

                            <Grid.Column width={9}>

                                <Dropdown
                                    fluid
                                    placeholder='Product Category'
                                    name="pCat"
                                    selection
                                    search
                                    clearable
                                    options={productCatList}
                                    onChange={this.handleProductCatChange}
                                    value={this.state.SelectedProductCatId}
                                />
                            </Grid.Column>

                            <Grid.Column width={6}>
                                {this.state.SelectedProductCatId === null ?
                                    <Label color="blue">
                                        {this.state.ProductCategoryWarning}
                                    </Label> : null}
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>

                            <Grid.Column width={1}>
                            </Grid.Column>

                            <Grid.Column width={9}>

                                <Dropdown
                                    fluid
                                    placeholder='Product Group'
                                    name="pGrp"
                                    selection
                                    search
                                    clearable
                                    options={productGrpList}
                                    onChange={this.handleProductGroupChange}
                                    value={this.state.SelectedProductGroupId}
                                />
                            </Grid.Column>

                            <Grid.Column width={6}>
                                {this.state.SelectedProductGroupId === null ?
                                    <Label color="blue">
                                        {this.state.ProductGroupWarning}
                                    </Label> : null}
                            </Grid.Column>
                        </Grid.Row>


                        <Grid.Row>
                            <Grid.Column width={1}>
                            </Grid.Column>

                            <Grid.Column width={9}>

                                <Dropdown
                                    fluid
                                    placeholder='Product'
                                    name="product"
                                    selection
                                    search
                                    clearable
                                    options={productList}
                                    onChange={this.handleProductChange}
                                    value={this.state.SelectedProductXrefId}
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                {this.state.SelectedProductXrefId === null ?
                                    <Label color="blue">
                                        {this.state.ProductWarning}
                                    </Label> : null}

                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                            <Grid.Column width={1}>
                            </Grid.Column>

                            <Grid.Column width={9}>

                                <Form.Group>
                                    <Form.Input
                                        placeholder='Qty'
                                        type="number"
                                        value={this.state.Quantity ? this.state.Quantity : 0}
                                        onChange={this.handleQuantityChange}
                                        width={2}
                                    />
                                </Form.Group>
                            </Grid.Column>

                            <Grid.Column width={6}>
                                {this.state.Quantity < 1 ?
                                    <Label color="blue">
                                        {this.state.QtyWarning}
                                    </Label> : null}

                            </Grid.Column>
                        </Grid.Row>

                    </Grid>

                    <br />

                </Modal.Content>

                <Modal.Actions>


                    <Button color='red'
                        onClick={() => this.CloseModal()}
                    >
                        {this.state.CloseModalText}
                    </Button>


                    <Button color='green'
                        onClick={() => this.AddToProductList()}
                    >
                        {this.state.AddModalText}
                    </Button>



                </Modal.Actions>

            </Modal>
        </div>);
    }
}